import React from 'react';
import { Navigate, RouteObject, createBrowserRouter } from 'react-router-dom';

import ActionGuard from 'src/components/ActionGuard';
import { Actions } from 'src/global/constants/role.constant';
import AdminLayout from 'src/layouts/AdminLayout';
import CreateProject from 'src/pages/create/page/CreateProject';
import DetailsNodeSale from 'src/pages/details/page/DetailsNodeSale';
import EditNodeSale from 'src/pages/edit/page/EditNodeSale';
import MasterAnalytics from 'src/pages/master-analytics/page/MasterAnalytics';
import NodeSaleList from 'src/pages/node-sale/page/NodeSaleList';
import OtcDetail from 'src/pages/otc-sales/details';
import Analytics from 'src/pages/project-dashboard/page/Analytics';
import { RolesProvider } from 'src/provider/RoleProvider';

const Home = React.lazy(() => import('src/pages/home/page/Home'));

interface ProtectedRouteProps {
  path: string;
  action: Actions;
  Component: React.ComponentType;
}

const createProtectedRoute = ({ path, action, Component }: ProtectedRouteProps): RouteObject => ({
  path,
  element: (
    <RolesProvider>
      <ActionGuard action={action}>
        <Component />
      </ActionGuard>
    </RolesProvider>
  ),
});

const protectedRoutes: RouteObject[] = [
  createProtectedRoute({
    path: '/core-sale',
    action: Actions.VIEW_LIST,
    Component: NodeSaleList,
  }),
  createProtectedRoute({
    path: '/core-sale/create',
    action: Actions.CREATE_PROJECT,
    Component: CreateProject,
  }),
  createProtectedRoute({
    path: '/core-sale/:id/edit',
    action: Actions.UPDATE,
    Component: EditNodeSale,
  }),
  createProtectedRoute({
    path: '/core-sale/:id',
    action: Actions.VIEW_LIST,
    Component: DetailsNodeSale,
  }),
  createProtectedRoute({
    path: '/core-sale/:id/otc/:otcId',
    action: Actions.VIEW_LIST,
    Component: OtcDetail,
  }),
  // createProtectedRoute({
  //   path: '/core-sale/:id/analytics',
  //   action: Actions.VIEW_LIST,
  //   Component: Analytics,
  // }),
  // createProtectedRoute({
  //   path: '/analytics',
  //   action: Actions.VIEW_LIST,
  //   Component: MasterAnalytics,
  // }),
];

const publicRoutes: RouteObject[] = [
  {
    path: '/',
    element: (
      <Navigate to='/core-sale' />
      // <RolesProvider>
      //   <Home />
      // </RolesProvider>
    ),
  },
];

const routes: RouteObject[] = [
  {
    path: '/',
    element: <AdminLayout />,
    children: [...protectedRoutes, ...publicRoutes], // Đính kèm các route con
  },
];
const router = createBrowserRouter(routes);

export default router;
